export const routerPaths = {
  ROOT: "/",
  LANDING: "/landing",
  SETTINGS: "/settings",
  PROFILE: "/profile",
  REGISTER: "/register",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/reset",
  VERIFY_EMAIL: "/verify-email",
  AUTH_HANDLER: "/auth-handler",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",
  CONSENT: "/consent",
  SENSITIVE_DATA: "/sensitive-data",
  CAREER_EXPLORER: "/career-explorer",
  KNOWLEDGE_HUB: "/knowledge-hub",
  KNOWLEDGE_HUB_DOCUMENT: "/knowledge-hub/:documentId",
  SKILLS_INTERESTS: "/skills-interests",
  CAREER_READINESS: "/career-readiness",
  CAREER_READINESS_MODULE: "/career-readiness/:moduleId",
  JOB_MATCHING: "/job-matching",
  FAQ: "/faq",
};
